import { BlindType } from './enumeration/BlindType.enum';
import { PlayerActionType } from './enumeration/PlayerActionType.enum';

export interface LogsResponse {
  tableId: string;
  events: EventsLog;
}

export interface LogEvent {
  pid: string;
  nick: string;
  blinds: BlindType[];
  action: PlayerActionType | BlindType;
  value: number;
  myBot: boolean;
  allIn: boolean;
  pot: number;
}

interface EventsLog {
  FLOP: LogEvent[];
  BLINDS: LogEvent[];
  TURN: LogEvent[];
  PREFLOP: LogEvent[];
  RIVER: LogEvent[];
}

export const createEmptyEventsLog = (): EventsLog => {
  return {
    FLOP: [],
    BLINDS: [],
    TURN: [],
    PREFLOP: [],
    RIVER: [],
  };
};
